export enum LanguageEnum {
    FR = "fr-FR",
    GB = "en-GB",
    ES = "es-ES",
}

export enum LocaleEnum {
    FR = "fr",
    EN = "en",
    GB = "en-gb",
    ES = "es",
}
